










import { Component, Vue } from "vue-property-decorator";
import { LayoutModule } from "@/store/layout";
import Size from "@/models/size";
import SizesAPI from "@/services/sizes";
import SizeForm from "./Components/SizeForm.vue";

@Component({
  components: { SizeForm },
})
export default class EditSize extends Vue {
  size: Size | null = null;
  loading = true;

  created(): void {
    if (this.$route.params.id) this.getSize();
  }

  async getSize(): Promise<void> {
    try {
      const r = await SizesAPI.getSize(this.$route.params.id);
      this.size = r;
    } catch (e) {
      console.log(e);
    } finally {
      this.loading = false;
    }
  }

  async save(size: Size): Promise<void> {
    LayoutModule.showLoader();
    try {
      await SizesAPI.updateSize(size);
      LayoutModule.setAlerts({
        text: this.$t("sizes.responses.success_update").toString(),
        type: "success",
      });
    } catch (e) {
      console.log(e);
    }
    LayoutModule.hideLoader();
  }

  cancel(): void {
    this.$router.push({ name: "sizes" });
  }
}
